import { string, object, mixed, array } from 'yup';
import type { TReminderTemplate } from '@src/shared/types/reminder-template';

export const createReminderTemplateInitialValues = (
  reminderTemplate?: TReminderTemplate
) => {
  return {
    attachments: [] as TReminderTemplate['attachments'],
    name: '',
    content: '',
    channel: '' as TReminderTemplate['channel'],
    category: '' as TReminderTemplate['category'],
    variables: {} as Record<string, string>,
    language: 'en',
    ...createInitialValueFromExistingTemplate(reminderTemplate),
  };
};

const createInitialValueFromExistingTemplate = (
  reminderTemplate?: TReminderTemplate
) => {
  if (!reminderTemplate) return {};

  return {
    attachments: reminderTemplate.attachments,
    name: reminderTemplate.name,
    content: reminderTemplate.content,
    channel: reminderTemplate.channel,
    category: reminderTemplate.category,
    variables: reminderTemplate.variables || {},
    language: reminderTemplate.language,
  };
};

export const reminderTemplateFormSchema = object().shape({
  attachments: array().of(mixed()),
  name: string().required('Name is required'),
  content: string().required('Content is required'),
  channel: string().required('Channel is required'),
  category: string().required('Category is required'),
  variables: object(),
  language: string().required('Language is required'),
});

export type TReminderTemplateFormValues = ReturnType<
  typeof createReminderTemplateInitialValues
>;
